// eslint-disable-next-line import/prefer-default-export
export const ORDER_STATUS_ICONS = {
  ordered: '👍',
  ordered_estimation: '🤔',
  payed: '💰',
  waiting_photo: '📸',
  estimating: '🔍',
  estimated: '💰',
  done: '✅',
  not_suitable: '⛔',
  declined: '❌',
};
